import {
  Grid,
  Box,
  TextField,
  Typography,
  makeStyles,
} from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { FinalNumbers } from "./FinalNumbers";
import { UnitCylinderCount } from "./UnitCylinderCount";
import { UnitForm } from "./UnitForm";
import { useHistory, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { LoadingComponent } from "components/Loading/LoadingComponent";

import Snackbar from "components/Snackbar/Snackbar";

import {
  navigateToSettlement,
  submitSettlementView,
} from "./actions/actionSettlement";
import { useSearch } from "hooks/useSearch";
import { GlobalBox } from "components/Box/GlobalBox";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import RegularButton from "components/CustomButtons/Button";
import LocalShippingIcon from "@material-ui/icons/LocalShipping";
import { validateObject } from "helpers/validateObject";
import {
  getSettlementUnitDispensers,
  assignSGC,
} from "redux/actions/routesStatus/routesStatusAction";
import { Autocomplete } from "@material-ui/lab";
import { ModalV2 } from "components/Modal/ModalV2";
import { useToggle } from "hooks/useToggle";
import { formatCustomDate } from "helpers/dateTools";
import { FormEndownmentsAccount } from "./FormEndownmentsAccount";
import { EndowmentsAccountInfo } from "./EndownmentsAccountInfo";
import { liquidationStatus } from "helpers/dictionary";
import { persistLocalStorage } from "helpers/localstorageTool";

const useStyles = makeStyles({
  clearIndicator: {
    position: "absolute",
    top: -7,
    right: 0,
  },
});

export const SettlementView = () => {
  const searchType = JSON.parse(localStorage.getItem("isLiquidation"));
  const dispatch = useDispatch();
  const hist = useHistory();

  const classes = useStyles();

  const { settlement, station: stationR } = useSelector(
    ({ routesStatus }) => routesStatus,
  );
  const isCondonation = !settlement?.notes?.every(
    (note) => note?.methodPayment?.toLowerCase() !== "condonacion",
  );
  const { config } = useSelector(({ login }) => login);
  const { startDate, endDate, station } = useSelector(
    ({ liquidations }) => liquidations,
  );
  const isManual = settlement?.routes?.end?.isManual === 1;
  const { color, message, isOpen, isLoadingComp } = useSelector(
    ({ search }) => search,
  );
  const [selectSgc, setSelectSgc] = useState(null);

  const { id } = useParams();
  const handleSGC = (v) => {
    setSelectSgc(v);
  };
  const { sgc } = useSelector(({ sgc }) => sgc);

  const { clearSnackbar, setSnackbar } = useSearch();
  const [typeUnit, setTypeUnit] = useState(false);
  const [open, setOpen] = useToggle();
  const { unit } = settlement;
  const handleNav = () => navigateToSettlement(searchType, dispatch, hist);
  const navAfterPrint = () => {
    hist.push("/admin/inicio_fin_ruta");
  };

  const handleSubmit = () =>
    submitSettlementView(
      { ...settlement, id, sgc: selectSgc?.name, idStation: stationR?.id },
      dispatch,
      searchType,
      navAfterPrint,
      {
        startDate,
        endDate,
        station: station?.id ? station : stationR.id,
      },
      config.printer,
    );

  useEffect(() => {
    if (unit?.unitManualConf && unit?.type === "ESTACION")
      dispatch(getSettlementUnitDispensers(unit?.id));

    if (validateObject(settlement, true)) {
      searchType
        ? hist.push("/admin/lista-liquidaciones")
        : hist.push("/admin/inicio_fin_ruta");
    }

    settlement?.unit?.type === "PORTATIL"
      ? setTypeUnit(false)
      : setTypeUnit(true);

    persistLocalStorage("route-share", { isSharing: true, route: null });
    //eslint-disable-next-line
  }, []);

  const addSgcForm = () => {
    const form = {
      date: formatCustomDate(new Date(), "-"),
      unitNumber: settlement.unit.number,
      sgc: selectSgc?.name,
      printConfig: config.printer,
      folio: settlement.folio ?? "",
    };
    if (
      settlement.settlementStatus === "SAVED" &&
      !settlement.notes?.every(
        (note) => note?.methodPayment?.toLowerCase() !== "condonacion",
      )
    ) {
      dispatch(setSnackbar("Faltan confirmar condonaciones", "warning"));
    }
    dispatch(assignSGC(form, { id }, navAfterPrint));
  };

  return (
    <>
      {validateObject(settlement) || settlement?.unitManualConf ? (
        <GlobalBox
          icon={<LocalShippingIcon />}
          title={`Liquidación ${isManual ? "Manual" : ""}`}
          controls={
            <>
              <Box
                style={{
                  width: 300,
                }}
              >
                {settlement?.fillingOrder !== null &&
                settlement?.fillingOrder?.length > 0 ? (
                  <Typography variant="body1">
                    {settlement?.fillingOrder[0]?.fillingStation}
                  </Typography>
                ) : (
                  settlement.unit.type !== "ESTACION" && (
                    <Autocomplete
                      id="settlement-sgc-select"
                      options={sgc}
                      getOptionLabel={(option) => option.name || ""}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Seleccione SGC"
                          variant="outlined"
                          size="small"
                          fullWidth
                        />
                      )}
                      onChange={(e, v) => handleSGC(v)}
                      noOptionsText="No se encuentra la planta"
                      popupIcon={false}
                      disabled={
                        isLoadingComp?.loadingSettlement ||
                        isLoadingComp?.loadingSGC
                      }
                      // disableClearable={true}
                      classes={{
                        clearIndicator: classes.clearIndicator,
                      }}
                    />
                  )
                )}
              </Box>
              {settlement.unit.type !== "ESTACION" ||
              settlement.settlementStatus !==
                liquidationStatus.value.CONFIRMED ? (
                <>
                  {!isLoadingComp.loadingSettlement && (
                    <RegularButton
                      color="info"
                      onClick={
                        settlement.fillingOrder === null &&
                        settlement.settlementStatus !== "SAVED"
                          ? addSgcForm
                          : handleSubmit
                      }
                      // disabled={
                      //   !selectSgc?.id || settlement?.fillingOrder?.length > 0 || settlement.settlementStatus == liquidationStatus.value.CONFIRMED
                      // }
                      disabled={
                        settlement.settlementStatus ===
                        liquidationStatus.value.CONFIRMED
                      }
                      loading={isLoadingComp?.loadingSettlement}
                    >
                      {settlement.fillingOrder === null &&
                      settlement.settlementStatus !== "SAVED"
                        ? "Agregar SGC a Liquidación"
                        : `${
                            isCondonation ? "Guardar" : "Confirmar"
                          } Liquidación`}
                    </RegularButton>
                  )}
                </>
              ) : (
                !isLoadingComp.loadingSettlement ||
                settlement?.settlementStatus !==
                  liquidationStatus.value.CONFIRMED(
                    <RegularButton
                      round={isLoadingComp?.loadingSettlement}
                      justIcon={isLoadingComp?.loadingSettlement}
                      color="info"
                      size="sm"
                      onClick={handleSubmit}
                      loading={isLoadingComp?.loadingSettlement}
                      disabled={
                        settlement?.fillingOrder?.length > 0 ||
                        settlement.settlementStatus !==
                          liquidationStatus.value.CONFIRMED
                      }
                    >
                      {`${isCondonation ? "Guardar" : "Confirmar"} Liquidación`}
                    </RegularButton>,
                  )
              )}
              <RegularButton
                round
                justIcon
                color="info"
                size="sm"
                onClick={handleNav}
                tooltip="Volver"
                disabled={isLoadingComp?.loadingSettlement}
              >
                <ChevronLeftIcon style={{ margin: 0 }} />
              </RegularButton>
            </>
          }
        >
          <Grid
            container
            spacing={1}
            fullWidth
            style={{
              opacity:
                isLoadingComp?.loadingSettlement || isLoadingComp?.loadingSGC
                  ? 0.5
                  : 1,
            }}
          >
            <UnitForm />
            <UnitCylinderCount block={typeUnit} />
            <FinalNumbers block={typeUnit} />
            <EndowmentsAccountInfo
              block={typeUnit}
              nav={handleNav}
              submit={handleSubmit}
              searchType={searchType}
            />
          </Grid>
          <Snackbar
            place="tr"
            color={color}
            message={message}
            open={isOpen}
            closeNotification={clearSnackbar}
            close
          />
        </GlobalBox>
      ) : (
        <LoadingComponent />
      )}
      <ModalV2 open={open} onClose={setOpen} toRight title="Agregar Notas">
        <FormEndownmentsAccount close={setOpen} editNote />
      </ModalV2>
    </>
  );
};
